export enum RouterProperties {
    salons = 'salons',
    clients = 'clients',
    clientVisits = 'visits',
    clientNotes = 'visits',
    ClientDetailNotes = 'ClientDetailNotes',

    newServices = 'newServices',
    services = 'services',
    servicesCategory = 'servicesCategory',
    oldServicesCategory = 'oldServicesCategory',
    oldPartnerServices = 'oldPartnerServices',

    listedProducts = 'ListedProducts',


    clientDocuments = 'clientDocuments',
    clientsaccounts = 'clientsaccounts',
    clientsaccountsAll = 'clientsAccountsAll',
    clientsAccountsHistory = 'clientsAccountsHistory',
    ClientDetailLoyaltyPage = 'ClientDetailLoyaltyPage',
    clientsDetailLoyaltySubscriptions = 'clientsDetailLoyaltySubscriptions',
    clientsDetailLoyaltyCertificates = 'clientsDetailLoyaltyCertificates',
    stores = 'stores',
    products = 'products',
    operations = 'operations',
    warehouse = 'warehouse',
    products_mass = 'products_mass',
    products_archived = 'products_archived',
    settingsUser = 'settingsUser',
    settingsRoles = 'settingsRoles',
    settingsFinance = 'settingsFinance',
    settingsCategories = 'settingsCategories',
    settingsSite = 'settingsSite',
    financeOperations = 'financeOperations',
    loyaltyCert = 'loyaltyCert',
    loyaltyCertType = 'loyaltyCertType',
    loyaltySubscription = 'loyaltySubscription',
    loyaltySubscriptionType = 'loyaltySubscriptionType',
    salonDetailClients = 'salonDetailClients',
    salonsDetailFinance = 'salonsDetailFinance',
    counterparties = "counterparties",
    newPartnerServicesPage = "newPartnerServicesPage",
    mutualSettlements = "mutualSettlements",
    SettlementPerDay = "SettlementPerDay",
    SettlementPerPeriod = "SettlementPerPeriod",
    BonusesAndPenalties = "BonusesAndPenalties",
    cosmetologCard = "cosmetologCard",
    CalculationCriteria = "CalculationCriteria",
    CalculationSchemes = "CalculationSchemes",
    CreateNewCriteria = "CreateNewCriteria",
    CreateNewRule = "CreateNewRule",
    WageCalculationScheme = "WageCalculationScheme",
    NewScheme = "NewScheme",
    settingsCategoriesSource = "settingsCategoriesSource"
}
